import React from "react";
import { Button } from "@/components/ui/button";
import { Plus, Search, Mic, MessageCircle, Bell, PieChart, Activity, Settings } from "lucide-react";
import { HeaderNotifications } from "@/components/layout/HeaderNotifications";
import { NotesWidget } from "@/components/notes/NotesWidget";
import { NotificationDropdown } from "@/components/notifications/NotificationDropdown";

interface FloatingActionBarProps {
  onQuickAdd: () => void;
  onTaskSearch: () => void;
  onVoiceAssistant: () => void;
  onAiAssistant: () => void;
  onNotifications: () => void;
  onReporting: () => void;
  onActivity: () => void;
}

export const FloatingActionBar: React.FC<FloatingActionBarProps> = ({
  onQuickAdd,
  onTaskSearch,
  onVoiceAssistant,
  onAiAssistant,
  onNotifications,
  onReporting,
  onActivity,
}) => {
  return (
    <div className="sticky top-0 z-40 bg-background/80 backdrop-blur-sm border-b px-4 py-2">
      <div className="flex items-center justify-center gap-1 overflow-x-auto">
        {/* First two icons with circular styling */}
        <Button
          variant="outline"
          size="icon"
          onClick={onQuickAdd}
          className="shrink-0 rounded-full h-8 w-8"
        >
          <Plus className="h-4 w-4" />
        </Button>
        <Button
          variant="outline"
          size="icon"
          onClick={onTaskSearch}
          className="shrink-0 rounded-full h-8 w-8"
        >
          <Search className="h-4 w-4" />
        </Button>
        
        {/* Rest of icons - icon only, no button styling */}
        <div className="h-8 w-8 flex items-center justify-center cursor-pointer" onClick={onReporting}>
          <PieChart className="h-4 w-4 text-muted-foreground" />
        </div>
        <div className="h-8 w-8 flex items-center justify-center cursor-pointer" onClick={onActivity}>
          <Activity className="h-4 w-4 text-muted-foreground" />
        </div>
        <div className="h-8 w-8 flex items-center justify-center cursor-pointer" onClick={onVoiceAssistant}>
          <Mic className="h-4 w-4 text-muted-foreground" />
        </div>
        <div className="h-8 w-8 flex items-center justify-center cursor-pointer" onClick={onAiAssistant}>
          <MessageCircle className="h-4 w-4 text-muted-foreground" />
        </div>
        
        {/* Notification components */}
        <div className="flex items-center gap-1 mt-1">
          <HeaderNotifications />
          <NotesWidget />
          <NotificationDropdown 
            onTaskClick={(taskId, taskTable) => {
              // Mobile navigation handling can be added here
            }} 
          />
        </div>
      </div>
    </div>
  );
};